export default {
  promoBanner: {
    mcp: {
      badge: 'MCP',
      title: 'Boostez votre productivité avec BEEM MCP',
      subtitle: 'Interrogez votre entrepôt de données, explorez vos tableaux de bord et gérez vos pipelines — directement depuis vos outils IA.',
      cta: 'Installer MCP',
    },
  },
};
